// import jwt from 'jsonwebtoken';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import { LocationOrigin } from "./utilityServices"
let isRefreshTokenInProgress = false;
export const Authentication = {

    async isAccessTokenAvailable() {
        let userToken = localStorage.getItem("iMSAccessToken");
        if (!userToken) {
            //window.location.reload();
        }
        return userToken ? true : false;
    },
    async setAccessToken(userToken, refreshToken) {
        localStorage.setItem("iMSAccessToken", userToken);
        localStorage.setItem("iMSRefreshToken", refreshToken);
    },
    async getAccessToken() {
        let token = localStorage.getItem("iMSAccessToken");
        if (await this.tokenHasExpired(token)) {
            if (!isRefreshTokenInProgress) {
                const freshToken = await this.refreshToken();
                return freshToken;
            } else {
                do {
                    await this.sleep(2000)
                } while (isRefreshTokenInProgress);
                token = localStorage.getItem("iMSAccessToken");
                return token;
            }

        } else {
            // Token is fresh, return it
            return token;
        }
    },
    async sleep(ms) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    },
    async tokenHasExpired(accessToken) {
        //const decodedToken = jwt.decode(accessToken);
        const decodedToken = jwtDecode(accessToken);
        //const decodedToken ={}
        // Divide milliseconds since Epoch and round up
        // We would rather be over than under
        // This would be better handled with Moment.js
        const now = new Date();
        const currentTimeInSeconds = Math.ceil(now.getTime() / 1000);
        // Compare the token's expiration to the current time
        // Consider the token to expire a little early to avoid expiration before use
        if (decodedToken.exp - 1 < currentTimeInSeconds) {
            return true;
        } else {
            return false;
        }
    },
    async accessToken(accessToken) {
        let _body = { "accessToken": accessToken }
        var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_JWT}userAuthentication`;
        //url = `http://localhost:8091${process.env.REACT_APP_IMS_API_JWT}userAuthentication`;
        let res, _accessToken;

        await axios.post(url, _body, {
            headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
            },
        }).then((response) => {
            res = response.data;
            this.setAccessToken(res.accessToken, res.refreshToken);
            _accessToken = res.accessToken;
            // localStorage.setItem('iMSAccessToken', res.accessToken);
            // localStorage.setItem('iMSRefreshToken', res.refreshToken);
        }).catch((error) => {
            console.log(error);
        });
        return _accessToken;
    },
    async refreshToken() {
        isRefreshTokenInProgress = true;
        var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_JWT}userRefreshToken`;
        //url = `http://localhost:8091${process.env.REACT_APP_IMS_API_JWT}userRefreshToken`;
        let token = localStorage.getItem("iMSAccessToken");
        let refreshToken = localStorage.getItem("iMSRefreshToken");
        if (!refreshToken || !token) {
            //window.location.reload();
        }
        const body = {
            accessToken: token,
            refreshToken: refreshToken
        };
        let _freshAccessToken = '';
        try {
            await axios({
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                },
                data: body,
                url,
            }).then((response) => {
                let res = response.data;
                this.setAccessToken(res.accessToken, res.refreshToken);
                isRefreshTokenInProgress = false;
                _freshAccessToken = res.accessToken;
                return res.accessToken;
            }).catch(async (error) => {
                console.log(error);
                let _accessToken = localStorage.getItem('AccessToken')
                _freshAccessToken = await this.accessToken(_accessToken);
                //window.location.reload();
                isRefreshTokenInProgress = false;
                return _freshAccessToken;
            }).finally(() => {
                isRefreshTokenInProgress = false;
            });
            return _freshAccessToken;
        }
        catch (error) {
            throw error;
        }

    },
    // async sleep(milliseconds) {
    //     const date = Date.now();
    //     let currentDate = null;
    //     do {
    //         console.log("sleep");
    //         currentDate = Date.now();
    //     } while (currentDate - date < milliseconds);
    // }
};